<template>
  <div class="paybillList">
    <div class="header" v-if="content.CurrencyList && content.CurrencyList.length > 0">
      <van-row class="currency-row">
        <van-col span="6"></van-col>
        <van-col
          span="6"
          v-for="(currency, index) in content.CurrencyList"
          :key="index"
          >{{ currency.CurrencySn }}</van-col
        >
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.paybillList.totalAmount }}</van-col>
        <van-col span="6">{{ content.Currency1_TotalAmount }}</van-col>
        <van-col span="6">{{ content.Currency2_TotalAmount }}</van-col>
        <van-col span="6">{{ content.Currency3_TotalAmount }}</van-col>
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.paybillList.approvedAmount }}</van-col>
        <van-col span="6">{{ content.Currency1_ApprovedAmount }}</van-col>
        <van-col span="6">{{ content.Currency2_ApprovedAmount }}</van-col>
        <van-col span="6">{{ content.Currency3_ApprovedAmount }}</van-col>
      </van-row>
    </div>
    <div class="content" v-if="content.PayBillList && content.PayBillList.length > 0">
      <div class="bill" v-for="(bill, index) in content.PayBillList" :key="index">
        <div class="bill-title">
          <div class="bill-title-left">
            <van-image width="15" height="15" :src="paybillIcon"></van-image>
            <span>{{ bill.InvoiceNo }}</span>
          </div>
          <div class="bill-title-right">
            <span v-if="bill.BillState == 1" class="red">{{
              $t.paybillList.billState1
            }}</span>
            <span v-if="bill.BillState == 2" class="blue">{{
              $t.paybillList.billState2
            }}</span>
            <span v-if="bill.BillState == 3" class="green">{{
              $t.paybillList.billState3
            }}</span>
          </div>
        </div>
        <div class="bill-header">
          <van-row class="currency-row">
            <van-col span="6"></van-col>
            <van-col
              span="6"
              v-for="(currency, index) in content.CurrencyList"
              :key="index"
              >{{ currency.CurrencySn }}</van-col
            >
          </van-row>
          <van-row class="amount-row">
            <van-col span="6">{{ $t.paybillList.subTotalAmount }}</van-col>
            <van-col span="6">{{ bill.Currency1_SubTotalAmount }}</van-col>
            <van-col span="6">{{ bill.Currency2_SubTotalAmount }}</van-col>
            <van-col span="6">{{ bill.Currency3_SubTotalAmount }}</van-col>
          </van-row>
          <van-row class="amount-row">
            <van-col span="6">{{ $t.paybillList.subApprovedAmount }}</van-col>
            <van-col span="6">{{ bill.Currency1_SubApprovedAmount }}</van-col>
            <van-col span="6">{{ bill.Currency2_SubApprovedAmount }}</van-col>
            <van-col span="6">{{ bill.Currency3_SubApprovedAmount }}</van-col>
          </van-row>
        </div>
        <van-collapse v-model="activeNames" @change="getPayBillDetail(bill, $event)">
          <van-collapse-item :title="$t.paybillList.chargeMoney" :name="index">
            <template v-if="bill.items && bill.items.length > 0">
              <van-row class="bill-row" v-for="(detail, idx) in bill.items" :key="idx">
                <van-col span="12">{{ detail.ItemName }}</van-col>
                <van-col span="12">{{ detail.CurrencySymbol }} {{ detail.Rate }}</van-col>
              </van-row>
            </template>
            <van-loading
              size="24"
              type="spinner"
              color="#1a347b"
              style="padding: 10px; text-align: center"
              v-else
            />
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="cartBox" v-if="content.ShopCarList && content.ShopCarList.length > 0">
        <div class="cartContent">
          <div class="list-title">{{ $t.shopping.shopCarList }}</div>
          <div class="list">
            <div
              class="section"
              v-for="(product, index) in content.ShopCarList"
              :key="index"
            >
              <van-radio-group v-model="UCId" @change="handleRadioChange">
                <van-radio :name="product.UCId" @click="handleRadio"></van-radio>
                <product-cell :product="product"></product-cell>
              </van-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="tool-bar"
      v-if="content.PaymentAmountList && content.PaymentAmountList.length > 0"
    >
      <van-button type="info" block @click="handlePayment">{{
        $t.orderDetail.onPay
      }}</van-button>
    </div>

    <pay-window :WB_Number="content.WB_Number"></pay-window>

    <van-dialog
      :title="$t.paybillList.dialogCurrencyTitle"
      width="80%"
      v-model="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogSubmit"
      :cancel-button-text="$t.meta.cancel"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
      :before-close="
        (action, done) => {
          done(false);
        }
      "
    >
      <slot name="default">
        <div class="paybillList-alert">
          <van-form>
            <van-radio-group v-model="SCId">
              <van-cell-group>
                <van-cell
                  v-for="(currency, index) in content.PaymentAmountList"
                  :key="index"
                  :title="currency.CurrencySn + ' ' + currency.TotalAmountDue"
                  clickable
                  @click="SCId = currency.SCId"
                >
                  <template #right-icon>
                    <van-radio :name="currency.SCId" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </van-form>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Col,
  Row,
  Button,
  Collapse,
  CollapseItem,
  Loading,
  Form,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  Image,
} from "vant";
import PayWindow from "@components/payWindow/PayWindow.vue";
import ProductCell from "./components/ProductCell";

Vue.use(Col)
  .use(Row)
  .use(Button)
  .use(Collapse)
  .use(CollapseItem)
  .use(Loading)
  .use(Form)
  .use(Cell)
  .use(CellGroup)
  .use(Radio)
  .use(RadioGroup)
  .use(Image);

export default {
  name: "paybillList",
  components: {
    PayWindow,
    ProductCell,
  },
  data() {
    return {
      paybillIcon: require("@/assets/img/order/paybill.png"),
      wbNumber: "",
      nuclearAccountNo: "",
      content: {},
      activeNames: [],
      dialogVisible: false,
      SCId: null,
      UCId: null,
      checkRadioFlag: false,
    };
  },
  mounted() {},
  created() {
    const query = this.$route.query;
    if (query.wbNumber) {
      this.wbNumber = query.wbNumber;
      this.getCustomerPayBillList();
    }
    if (query.NuclearAccountNo) {
      this.nuclearAccountNo = query.NuclearAccountNo;
      this.getCustomerPayBillListByNuclearAccountNo();
    }
  },
  methods: {
    handleRadioChange() {
      this.checkRadioFlag = true;
    },
    handleRadio() {
      if (!this.checkRadioFlag) {
        this.UCId = null;
      }
      this.checkRadioFlag = false;
    },
    handlePayment() {
      if (this.content.PaymentAmountList.length > 1) {
        this.dialogVisible = true;
      } else {
        this.onPay(this.content.PaymentAmountList[0]);
      }
    },
    dialogSubmit() {
      var paymentData = null;
      for (var payment of this.content.PaymentAmountList) {
        if (payment.SCId == this.SCId) {
          paymentData = payment;
          break;
        }
      }
      this.onPay(paymentData);
    },
    onPay(paymentData) {
      var productData = null;
      for (var product of this.content.ShopCarList) {
        if (product.UCId == this.UCId) {
          productData = product;
          break;
        }
      }
      this.$bus.$emit("showPayWindow", { paymentData, productData });
      this.dialogVisible = false;
    },
    getCustomerPayBillList() {
      this.$commonMethod.showLoading();
      var param = {
        WB_Number: this.wbNumber,
      };
      return new Promise((resolve) => {
        this.$api.order
          .getCustomerPayBillList(param)
          .then((res) => {
            this.content = res.data;
            for (var bill of this.content.PayBillList) {
              bill.items = [];
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCustomerPayBillListByNuclearAccountNo() {
      this.$commonMethod.showLoading();
      var param = {
        NuclearAccountNo: this.nuclearAccountNo,
      };
      return new Promise((resolve) => {
        this.$api.order
          .getCustomerPayBillListByNuclearAccountNo(param)
          .then((res) => {
            this.content = res.data;
            for (var bill of this.content.PayBillList) {
              bill.items = [];
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getPayBillDetail(bill, event) {
      if (event.length > 0) {
        var param = {
          InvoiceNo: bill.InvoiceNo,
        };
        return new Promise((resolve) => {
          this.$api.order
            .getPayBillDetail(param)
            .then((res) => {
              setTimeout(() => {
                bill.items = res.data;
                this.$forceUpdate();
              }, 500);
              resolve(true);
            })
            .catch((error) => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
                msg: error.message,
              });
            });
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.paybillList {
  .header {
    padding: 10px;
    font-size: 14px;
    background: white;
    border-bottom: 1px solid #e5e5e5;
    .currency-row {
      border-radius: 5px;
      background: #1a347b;
      color: white;
      .van-col {
        padding-left: 10px;
        line-height: 35px;
      }
    }
    .amount-row {
      .van-col {
        padding-left: 10px;
        line-height: 35px;
      }
    }
  }
  .content {
    ::v-deep .van-collapse-item__content {
      padding: 10px;
    }
    .van-collapse-item {
      ::v-deep .van-cell {
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
      }
    }
    ::v-deep .van-cell__title {
      text-align: center;
      span {
        padding-left: 20px;
      }
    }
    .bill {
      width: 95%;
      margin: 2% auto auto auto;
      box-shadow: 0px 2.5px 6.5px 1px rgba(0, 0, 0, 0.1);
      .bill-title {
        padding: 10px;
        background: white;
        .bill-title-left {
          font-size: 14px;
          vertical-align: middle;
          display: inline-block;
          width: 70%;
          .van-image {
            vertical-align: middle;
            display: inline-block;
            margin-right: 5px;
          }
          span {
            vertical-align: middle;
            display: inline-block;
          }
        }
        .bill-title-right {
          font-size: 14px;
          vertical-align: middle;
          display: inline-block;
          width: 29%;
          text-align: right;
          margin-right: 1%;
          .red {
            color: red;
          }
          .blue {
            color: blue;
          }
          .green {
            color: green;
          }
        }
      }
      .bill-header {
        padding: 0px 10px 0px 10px;
        font-size: 14px;
        background: white;
        .currency-row {
          border-radius: 5px;
          background: #1a347b;
          color: white;
          .van-col {
            padding-left: 10px;
            line-height: 35px;
          }
        }
        .amount-row {
          .van-col {
            padding-left: 10px;
            line-height: 35px;
          }
        }
      }
    }
    .bill-row {
      .van-col {
        padding-right: 10px;
        text-align: center;
        line-height: 35px;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      background: #1a347b !important;
      border-radius: 0px;
      border: none;
    }
  }
  .paybillList-alert {
    overflow: scroll;
    height: auto;
    margin-top: 30px;
    margin-bottom: 30px;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
  }
  .cartBox {
    position: relative;
    box-sizing: border-box;
    margin-bottom: 40vw;
    .cartContent {
      position: relative;
      z-index: 2;
      padding: 20px;

      .list-title {
        margin: 0;
        font-size: 16px;
        font-weight: bold;
      }
      & > .list {
        margin-top: 14px;

        & > .section {
          margin-top: 15px;
          background-color: white;
          border-radius: 5px;
          box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.3);

          ::v-deep .product-cell {
            width: 85%;
            display: inline-block;
            vertical-align: middle;
            &:last-child {
              border-bottom-width: 0;
            }
          }

          ::v-deep .van-radio {
            display: inline-block;
            width: 15%;
            vertical-align: middle;
            .van-icon {
              margin: auto;
            }
            .van-radio__icon--checked {
              .van-icon-success {
                background-color: #132660;
                border-color: #132660;
              }
            }
          }

          &:first-child {
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>
